'use client';
import MarkDown from '@/utils/MarkDown/MarkDown';
import {useMediaQuery} from '@pixel-party/hooks/useMediaQuery';
import {usePathname} from 'next/navigation';
import SearchBox from '../SearchBox';
import type {HeroBannerContent} from './HeroBannerInterface';
import styles from './herobanner.module.scss';
import {subNavItems_en, subNavItems_es} from '@/utils/constants';
import {useEffect, useState} from 'react';

export default function HeroBanner({
  locale,
  title = '',
  isFeaturedArticlePage = false,
  landingPageHeroContent,
  searchPageHeroContent,
  placeHolderText,
}: {
  locale: string;
  title?: string;
  isFeaturedArticlePage?: boolean;
  landingPageHeroContent?: HeroBannerContent;
  searchPageHeroContent?: HeroBannerContent;
  placeHolderText?: string;
}) {
  const isTablet = useMediaQuery('(min-width: 600px)');
  const isDesktop = useMediaQuery('(min-width: 1024px)');
  const pathname = usePathname();
  const [bannerTitle, setBannerTitle] = useState(
    locale === 'en' ? subNavItems_en[0]?.title : subNavItems_es[0]?.title,
  );
  const subNavTitle = (data: any) => {
    data.map((item: any) => {
      if (item.title === title) {
        setBannerTitle(item.title);
      }
    });
  };
  useEffect(() => {
    if (locale === 'en') {
      subNavTitle(subNavItems_en);
    } else {
      subNavTitle(subNavItems_es);
    }
  }, [locale, title]);
  const heroBannerTitle = bannerTitle;
  return (
    <>
      <div
        className={`${styles['hero-banner']} ${!pathname?.includes('/search') && !isFeaturedArticlePage ? styles['hero-banner-home'] : ''}`}
      >
        <div className={styles['hero-banner__content']}>
          {!pathname?.includes('/search') && !isFeaturedArticlePage && (
            <div className={styles['hero-banner__title']}>
              <MarkDown content={landingPageHeroContent?.fields?.gfTitle} />
            </div>
          )}
          {isFeaturedArticlePage && (
            <h1 className={styles['hero-banner__title']}>{heroBannerTitle}</h1>
          )}
          {!isFeaturedArticlePage && (
            <div className={styles['hero-banner__search-bar']}>
              <SearchBox
                locale={locale}
                placeHolderText={placeHolderText}
              />
            </div>
          )}
        </div>

        <div className={styles['hero-banner__left']}>
          {!pathname?.includes('/search') && !isFeaturedArticlePage ? (
            <img
              crossOrigin="anonymous"
              src={
                isDesktop
                  ? landingPageHeroContent?.fields?.gfLeftBackgroundImageDesktop
                      ?.fields?.file?.url
                  : isTablet
                    ? landingPageHeroContent?.fields
                        ?.gfLeftBackgroundImageTablet?.fields?.file?.url
                    : landingPageHeroContent?.fields
                        ?.gfLeftBackgroundImageMobile?.fields?.file?.url
              }
              alt={
                landingPageHeroContent?.fields?.gfTitle?.content[0]?.content[0]
                  ?.value
              }
              title={
                landingPageHeroContent?.fields?.gfTitle?.content[0]?.content[0]
                  ?.value
              }
            />
          ) : (
            <img
              crossOrigin="anonymous"
              src={
                isDesktop
                  ? searchPageHeroContent?.fields?.gfLeftBackgroundImageDesktop
                      ?.fields?.file?.url
                  : isTablet
                    ? searchPageHeroContent?.fields
                        ?.gfLeftBackgroundImageDesktop?.fields?.file?.url
                    : searchPageHeroContent?.fields?.gfLeftBackgroundImageMobile
                        ?.fields?.file?.url
              }
              alt={heroBannerTitle}
              title={heroBannerTitle}
            />
          )}
        </div>
        <div
          className={` ${styles['hero-banner__right']} ${!pathname?.includes('/search') && !isFeaturedArticlePage ? styles['hero-banner-home__right'] : ''}`}
        >
          {!pathname?.includes('/search') && !isFeaturedArticlePage ? (
            <img
              crossOrigin="anonymous"
              src={
                isDesktop
                  ? landingPageHeroContent?.fields
                      ?.gfRightBackgroundImageDesktop?.fields?.file?.url
                  : isTablet
                    ? landingPageHeroContent?.fields
                        ?.gfRightBackgroundImageTablet?.fields?.file?.url
                    : landingPageHeroContent?.fields
                        ?.gfRightBackgroundImageMobile?.fields?.file?.url
              }
              alt={
                landingPageHeroContent?.fields?.gfTitle?.content[0]?.content[0]
                  ?.value
              }
              title={
                landingPageHeroContent?.fields?.gfTitle?.content[0]?.content[0]
                  ?.value
              }
            />
          ) : (
            <img
              crossOrigin="anonymous"
              src={
                isDesktop
                  ? searchPageHeroContent?.fields?.gfRightBackgroundImageDesktop
                      ?.fields?.file?.url
                  : isTablet
                    ? searchPageHeroContent?.fields
                        ?.gfRightBackgroundImageDesktop?.fields?.file?.url
                    : searchPageHeroContent?.fields
                        ?.gfRightBackgroundImageMobile?.fields?.file?.url
              }
              alt={heroBannerTitle}
              title={heroBannerTitle}
            />
          )}
        </div>
      </div>
    </>
  );
}
